import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { mockTopics, mockPosts, mockCategories } from '../data';

const TopicView: React.FC = () => {
  const { topicId } = useParams<{ topicId: string }>();
  
  const topic = mockTopics.find(t => t.id === topicId);
  const posts = mockPosts
    .filter(post => post.topicId === topicId)
    .sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
  
  const category = topic ? mockCategories.find(cat => cat.id === topic.categoryId) : null;

  if (!topic) {
    return (
      <div className="forum-container">
        <div className="forum-header">
          <h1 className="forum-title">Topic Not Found</h1>
        </div>
        <div className="text-center">
          <p>The requested topic could not be found.</p>
          <Link to="/" className="btn">Return to Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="topic-view">
      <div className="forum-container">
        <div className="forum-header">
          <div className="breadcrumb">
            <Link to="/">Home</Link> &gt; 
            <Link to={`/category/${category?.id}`}>{category?.name}</Link> &gt; 
            <span>{topic.title}</span>
          </div>
          <h1 className="forum-title">
            {topic.title}
            {topic.isSticky && <span style={{ color: '#ffff00' }}> [STICKY]</span>}
            {topic.isAnnouncement && <span style={{ color: '#ff0000' }}> [ANNOUNCEMENT]</span>}
          </h1>
          {topic.description && (
            <p className="forum-description">{topic.description}</p>
          )}
        </div>
        
        <div className="posts-container">
          {posts.map((post, index) => (
            <div key={post.id} className="post">
              <div className="post-header">
                <div className="post-author-info">
                  <span className="post-author">{post.author.username}</span>
                  <div className="post-meta">
                    <span>Posts: {post.author.postCount}</span>
                    <span>Joined: {new Date(post.author.joinDate).toLocaleDateString()}</span>
                  </div>
                </div>
                <div className="post-date">
                  {new Date(post.timestamp).toLocaleString()}
                  {post.lastEdited && (
                    <div style={{ fontSize: '0.8rem', color: '#666' }}>
                      (edited {new Date(post.lastEdited).toLocaleString()})
                    </div>
                  )}
                </div>
              </div>
              <div className="post-content" dangerouslySetInnerHTML={{ __html: post.content }} />
            </div>
          ))}
        </div>
        
        <div className="topic-footer">
          <div className="topic-stats">
            <span>Total Posts: {posts.length}</span>
            <span>Views: {topic.viewCount}</span>
            <span>Created: {new Date(topic.createdAt).toLocaleDateString()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopicView; 